<script>
import VsButton from 'viralstyle-ui/src/VsButton';
import VsInput from 'viralstyle-ui/src/VsInput';
import { mapState } from 'vuex';

import { paymentPaypalValidator } from '../_settings-validator';

export default {
  components: {
    VsInput,
    VsButton,
  },
  props: {
    hideSubmit: [Boolean, String],
  },
  data: () => ({
    paymentPaypalValidator,
  }),
  computed: mapState({
    processing: state => state.processing,
    paymentInfo: state => state.settings.paymentInfo,
    paymentInfoSubmitted: state => state.settings.paymentInfoSubmitted,
    originalPaymentInfo: state => state.settings.originalPaymentInfo,
  }),
  created() {
    paymentPaypalValidator.clear();

    if (this.originalPaymentInfo && this.paymentInfo.paypal_email !== this.originalPaymentInfo.paypal_email) {
      this.$store.commit('updateStateClone', { object: this.paymentInfo, property: 'paypal_email', value: this.originalPaymentInfo.paypal_email });
    }
  },
  updated() {
    this.$emit('update');
  },
  methods: {
    updatePaymentInfo(e, prop) {
      this.$store.commit('updatePaymentInfo', { prop, value: e.target.value });

      paymentPaypalValidator.validate(prop, e.target.value);
    },
    async savePaymentMethod() {
      let valid = await paymentPaypalValidator.validateAll({ paypal_email: this.paymentInfo.paypal_email });

      if (valid) {
        this.$store.dispatch('savePaymentMethod', { method: 'PAYPAL', prettyName: 'PayPal' });

        this.$store.commit('updateState', { object: this.paymentInfoSubmitted, property: 'PAYPAL', value: false });
      } else {
        this.$store.commit('updateState', { object: this.paymentInfoSubmitted, property: 'PAYPAL', value: true });
      }
    },
  },
};
</script>

<template lang='pug'>
.accordion-content__client
  vs-input(
    full-width,
    prevent-autofill,
    type='text',
    placeholder='Email',
    :value='paymentInfo.paypal_email',
    :error='paymentInfoSubmitted.PAYPAL && paymentPaypalValidator.hasError("paypal_email")',
    @input='updatePaymentInfo($event, "paypal_email")',
  )
  .vs-error(v-show='paymentInfoSubmitted.PAYPAL && paymentPaypalValidator.hasError("paypal_email")') {{paymentPaypalValidator.firstError('paypal_email')}}
  vs-button(
    v-if='!hideSubmit',
    text='save',
    icon='content-save',
    :processing='processing',
    :disabled='processing',
    @click='savePaymentMethod',
  )
</template>